var _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgThreeDots = function SvgThreeDots(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 177 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    rx: 8.081,
    ry: 7.87,
    transform: "matrix(.91578 -.40168 .4294 .90312 73.811 10.354)",
    fill: "#A2DCD2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    rx: 8.081,
    ry: 7.87,
    transform: "matrix(.91578 -.40168 .4294 .90312 11.778 127.565)",
    fill: "#82C6FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    rx: 9,
    ry: 8.705,
    transform: "matrix(.95868 -.28447 .3062 .95197 165.435 156.292)",
    fill: "#FFD67C"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThreeDots);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTc3IDE2OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZWxsaXBzZSBvcGFjaXR5PSIuOCIgcng9IjguMDgxIiByeT0iNy44NyIgdHJhbnNmb3JtPSJtYXRyaXgoLjkxNTc4IC0uNDAxNjggLjQyOTQgLjkwMzEyIDczLjgxMSAxMC4zNTQpIiBmaWxsPSIjQTJEQ0QyIi8+PGVsbGlwc2Ugb3BhY2l0eT0iLjgiIHJ4PSI4LjA4MSIgcnk9IjcuODciIHRyYW5zZm9ybT0ibWF0cml4KC45MTU3OCAtLjQwMTY4IC40Mjk0IC45MDMxMiAxMS43NzggMTI3LjU2NSkiIGZpbGw9IiM4MkM2RkYiLz48ZWxsaXBzZSBvcGFjaXR5PSIuOCIgcng9IjkiIHJ5PSI4LjcwNSIgdHJhbnNmb3JtPSJtYXRyaXgoLjk1ODY4IC0uMjg0NDcgLjMwNjIgLjk1MTk3IDE2NS40MzUgMTU2LjI5MikiIGZpbGw9IiNGRkQ2N0MiLz48L3N2Zz4=";